import React from 'react';
import { css } from '@emotion/core';
import { Tablet, Desktop } from '../../constants/responsive';
import { FormattedHTMLMessage } from 'gatsby-plugin-intl';

// 【投资组合】卡片
const AdvisoryFeeCard = ({ id }) => {
  return (
    <div
      css={css`
        border-radius: 10px;
        overflow: hidden;

        text-align: center;
        box-shadow: 0 0 15px 0 rgba(34, 34, 34, 0.08);

        max-width: 160.7px;
        width: 160.7px;
        ${Tablet} {
          width: 231.9px;
          max-width: 300px;
        }
        ${Desktop} {
          width: 278px;
        }
      `}
    >
      {/* grid 1 */}
      <div
        css={css`
          background: #ebebeb;
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 79px;
          ${Tablet} {
            height: 79px;
          }
          ${Desktop} {
            height: 111px;
          }
        `}
      >
        <span
          css={css`
            font-weight: 500;
            font-size: 12px;
            line-height: 1;
            ${Tablet} {
              font-size: 12px;
              line-height: 1;
            }
            ${Desktop} {
              font-size: 16px;
              line-height: 1.25;
            }
          `}
        >
          <FormattedHTMLMessage id={`fee.annual.portfolio-${id}.1.text-1`} />
        </span>
        <span
          css={css`
            font-weight: bold;
            font-size: 20px;
            line-height: 1.6;

            ${Tablet} {
              font-size: 20px;
              line-height: 1.6;
            }
            ${Desktop} {
              font-size: 35px;
              line-height: 1.57;
            }
          `}
        >
          <FormattedHTMLMessage id={`fee.annual.portfolio-${id}.1.text-2`} />
        </span>
      </div>
      {/* grid 2 */}
      <div
        css={css`
          display: flex;
          flex-direction: column;
          justify-content: center;
          border-bottom: 0.5px solid rgba(173, 173, 173, 0.24);
          height: 80.3px;
          ${Tablet} {
            height: 80.3px;
          }
          ${Desktop} {
            height: 99.6px;
          }
        `}
      >
        <span
          css={css`
            font-weight: bold;
            margin-bottom: 0;
            line-height: 1;
            font-size: 20px;
            margin-bottom: 10px;
            ${Tablet} {
              line-height: 1;
              font-size: 20px;
              margin-bottom: 10px;
            }
            ${Desktop} {
              line-height: 0.83;
              font-size: 30px;
              margin-bottom: 9px;
            }
          `}
        >
          <FormattedHTMLMessage id={`fee.annual.portfolio-${id}.2.text-1`} />
        </span>
        <span
          css={css`
            font-weight: normal;
            line-height: 1.1;
            font-size: 10px;
            ${Tablet} {
              line-height: 1.1;
              font-size: 10px;
            }
            ${Desktop} {
              line-height: 1.25;
              font-size: 12px;
            }
          `}
        >
          <FormattedHTMLMessage id={`fee.annual.portfolio-${id}.2.text-2`} />
        </span>
      </div>
      {/* grid 3 */}
      <div
        css={css`
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 79.2px;
          padding: 0 3px;
          ${Tablet} {
            padding: 0;
            height: 79.2px;
          }
          ${Desktop} {
            height: 99.9px;
          }
        `}
      >
        <span
          css={css`
            font-weight: bold;
            margin: 0 0 5px 0;
            line-height: 1;
            font-size: 20px;
            margin-bottom: 10px;
            ${Tablet} {
              line-height: 1;
              font-size: 20px;
              margin-bottom: 10px;
            }
            ${Desktop} {
              line-height: 0.83;
              font-size: 30px;
              margin-bottom: 9px;
            }
          `}
        >
          0%
        </span>

        <span
          css={css`
            font-weight: normal;
            line-height: 1.1;
            font-size: 10px;
            ${Tablet} {
              line-height: 1.1;
              font-size: 10px;
            }
            ${Desktop} {
              line-height: 1.25;
              font-size: 12px;
            }
          `}
        >
          <FormattedHTMLMessage id={`fee.annual.portfolio-${id}.3.text-2`} />
        </span>
      </div>
    </div>
  );
};
// 【个股】卡片
const StockTradingFeeCard = ({ id }) => {
  return (
    <div
      css={css`
        border-radius: 10px;
        overflow: hidden;
        text-align: center;
        box-shadow: 0 0 15px 0 rgba(34, 34, 34, 0.08);
        margin-bottom: 13.3px;
        :last-child {
          margin-bottom: 8.9px;
        }
        width: 100%;
        ${Tablet} {
          margin-bottom: 14.7px;
          :last-child {
            margin-bottom: 14.7px;
          }
          width: 204.6px;
        }
        ${Desktop} {
          margin-bottom: 25.7px;
          :last-child {
            margin-bottom: 25.7px;
          }
          width: 278px;
        }
      `}
    >
      {/* grid 1 */}
      <div
        css={css`
          background: #ebebeb;
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 52.3px;

          ${Tablet} {
            height: 52.3px;
          }
          ${Desktop} {
            height: 52.3px;
          }
        `}
      >
        <span
          css={css`
            font-weight: bold;
            font-size: 12px;
            line-height: 1.25;
            ${Tablet} {
              font-weight: 500;
              font-size: 12px;
              line-height: 1.25;
            }
            ${Desktop} {
              font-size: 16px;
              line-height: 0.94;
            }
          `}
        >
          <FormattedHTMLMessage
            id={`fee.stock-trading.portfolio-${id}.1.text-1`}
          />
        </span>
      </div>
      {/* grid 2 */}
      <div
        css={css`
          display: flex;
          flex-direction: column;
          justify-content: center;
          border-bottom: 0.5px solid rgba(173, 173, 173, 0.24);
          height: 70.5px;
          ${Tablet} {
            height: 92.1px;
          }
          ${Desktop} {
            height: 92.1px;
          }
        `}
      >
        <span
          css={css`
            font-weight: bold;
            line-height: 1.67;
            font-size: 12px;

            ${Tablet} {
              font-weight: 500;
              line-height: 1.67;
              font-size: 12px;
            }
            ${Desktop} {
              line-height: 1.25;
              font-size: 16px;
            }
          `}
        >
          <FormattedHTMLMessage
            id={`fee.stock-trading.portfolio-${id}.2.text-1`}
          />
        </span>
        <span
          css={css`
            font-weight: normal;
            line-height: 1.25;
            font-size: 12px;
            ${Tablet} {
              line-height: 1.67;
              font-size: 12px;
            }
            ${Desktop} {
              line-height: 1.25;
              font-size: 16px;
            }
          `}
        >
          <FormattedHTMLMessage
            id={`fee.stock-trading.portfolio-${id}.2.text-2`}
          />
        </span>
      </div>
      {/* grid 3 */}
      <div
        css={css`
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 83.4px;
          ${Tablet} {
            height: 98.1px;
          }
          ${Desktop} {
            height: 98.1px;
          }
        `}
      >
        <span
          css={css`
            font-weight: bold;

            line-height: 1.67;
            font-size: 12px;

            ${Tablet} {
              font-weight: 500;
              line-height: 1.67;
              font-size: 12px;
            }
            ${Desktop} {
              line-height: 1.25;
              font-size: 16px;
            }
          `}
        >
          <FormattedHTMLMessage
            id={`fee.stock-trading.portfolio-${id}.3.text-1`}
          />
        </span>

        <span
          css={css`
            font-weight: normal;
            line-height: 1.25;
            font-size: 12px;
            ${Tablet} {
              line-height: 1.67;
              font-size: 12px;
            }
            ${Desktop} {
              line-height: 1.25;
              font-size: 16px;
            }
          `}
        >
          <FormattedHTMLMessage
            id={`fee.stock-trading.portfolio-${id}.3.text-2`}
          />
        </span>
      </div>
    </div>
  );
};

export { AdvisoryFeeCard, StockTradingFeeCard };
